/** @format */

import React, { useEffect, useRef } from 'react';

const InformationWidget = props => {
  const { data, onSizeChange, globalLayouts, currentBreakPoint } = props;
  const measureRef = useRef();
  const innerRef = useRef();

  useEffect(() => {
    if (!innerRef.current || Object.keys(globalLayouts).length === 0) return;
    if (onSizeChange && measureRef.current) {
      // const resizeObserver = new ResizeObserver(entries => {
      onSizeChange(innerRef.current.offsetHeight);
      // });
      // resizeObserver.observe(measureRef.current);
      // return () => resizeObserver.disconnect();
    }
  }, [measureRef, innerRef, globalLayouts, currentBreakPoint]);

  return (
    <div className="information-widget" data-width={data.w} data-height={data.h} ref={measureRef}>
      <div className="information-widget-inner" ref={innerRef}>
        <h2 className="information-widget-title">{data.title}</h2>
        <div
          className="information-widget-content content-block"
          dangerouslySetInnerHTML={{ __html: data.content }}
        ></div>
      </div>
    </div>
  );
};

export { InformationWidget };
